<template>
  <div
    class="border-gray-300 lg:pl-13 h-[400px] space-y-2.5 border px-5 py-9 lg:min-w-80 lg:pr-7"
  >
    <Skeleton type="custom" class="mb-4 h-7 w-24" />
    <hr class="!mb-4" />
    <div class="flex w-full justify-between">
      <Skeleton type="custom" class="h-3 w-28" />
      <Skeleton type="custom" class="h-3 w-16" />
    </div>
    <div class="flex w-full justify-between">
      <Skeleton type="custom" class="h-3 w-16" />
      <Skeleton type="custom" class="h-3 w-12" />
    </div>
    <div class="!mb-4 flex w-full justify-between">
      <Skeleton type="custom" class="h-3 w-20" />
      <Skeleton type="custom" class="h-3 w-10" />
    </div>
    <hr class="!mb-4" />
    <div class="flex w-full justify-between">
      <Skeleton type="custom" class="h-5 w-32" />
      <Skeleton type="custom" class="h-5 w-16" />
    </div>
    <Skeleton type="custom" class="!mb-5 h-2 w-12" />
    <Skeleton type="custom" class="!mb-3 h-12 w-full" />
    <Skeleton type="custom" class="!mb-1 h-2 w-full" />
    <Skeleton type="custom" class="!mt-0 h-2 w-2/3" />
    <div class="flex gap-2 pt-3">
      <Skeleton
        v-for="i in 4"
        :key="`payment-card-skeleton-${i}`"
        type="custom"
        class="h-[35px] w-[50px]"
      />
    </div>
  </div>
</template>
